import { WidgetType } from '../../../shared/constants/widget';
import InsightsWidgetLoader from '../InsightsWidgetLoader';

export function PageHeadingSkeleton() {
  return (
    <div className="bg-black-200 mb-2 h-12 max-w-[662px] animate-pulse rounded-lg" />
  );
}

export function HeadingFilterSkeleton() {
  return (
    <>
      <div className="mb-3 flex items-center justify-between">
        <div className="flex gap-x-[11px]">
          <div className="bg-black-200 h-[41.33px] w-[104px] animate-pulse rounded-lg"></div>
          <div className="bg-black-200 h-[41.33px] w-[104px] animate-pulse rounded-lg"></div>
          <div className="bg-black-200 h-[41.33px] w-[104px] animate-pulse rounded-lg"></div>
          <div className="bg-black-200 h-[41.33px] w-[104px] animate-pulse rounded-lg"></div>
          <div className="bg-black-200 h-[41.33px] w-[104px] animate-pulse rounded-lg"></div>
        </div>
        <div className="bg-black-200 h-10 w-[95px] animate-pulse rounded-lg"></div>
      </div>
      <div className="bg-black-200 mb-6 flex h-9 animate-pulse rounded-lg"></div>
      <div className="bg-black-200 mb-8 flex h-11 animate-pulse rounded-lg"></div>
    </>
  );
}

function getSkeletonProperties(type?: WidgetType): {
  height: number;
  showLoadingText: boolean;
} {
  if (
    type === WidgetType.FLASH_CARD ||
    type === WidgetType.BENCHMARK_SCORE_CARD ||
    type === WidgetType.ICON_CARDS ||
    type === WidgetType.SCORE_INFO_CARD
  ) {
    // for small cards, no loading text because they takes up space
    return {
      height: 248,
      showLoadingText: false,
    };
  }
  if (type === WidgetType.RECOMMENDATIONS_CARD) {
    return {
      height: 248,
      showLoadingText: false,
    };
  }
  if (
    type === WidgetType.BAR_CHART_WITH_TREND ||
    type === WidgetType.PIE_CHART_CLUSTER
  ) {
    return {
      height: 248,
      showLoadingText: false,
    };
  }
  return {
    height: 248,
    showLoadingText: false,
  };
}

export function SkeletonLoader({ type }: { type: WidgetType }) {
  const { showLoadingText } = getSkeletonProperties(type);

  return <InsightsWidgetLoader showLoadingText={showLoadingText} />;
}

export function TablePaginationSkeleton() {
  return <div className="bg-black-200 h-[366px] animate-pulse"></div>;
}
